import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
// import MatchQueueFilterComponent from './matchQueueFilter';
// import FloatingLeftNav from './floatingLeftNav';
import rose from '../../assets/images/rose.svg';
import heart2 from '../../assets/images/hear3.svg';
import heart from '../../assets/images/hear2.svg';
// import closeImg from '../../assets/images/close.svg';
import skipImg from '../../assets/images/skip.svg';
import blockImg from '../../assets/images/block.svg';
import heartwhite from '../../assets/images/hear-white2.svg';
import resetFilterIcons from '../../assets/images/Reset-Filter.svg';
import alreadylike from '../../assets/images/alreadyLike.png';
import filterIconwhite from '../../assets/images/Filter-white.svg';
import ImageSlider2 from './imageSlider2';
// FREE MODE (sheet #19): PlanBadge is not rendered on member cards for now.
// import { PlanBadge, ResidenceCity, OriginState } from './ProfileMeta';
import { ResidenceCity, OriginState } from './ProfileMeta';
import ageIcon from '../../assets/images/Cake.svg';
import Back from '../../assets/images/backicon.svg';
import ageIconWhite from '../../assets/images/Cake_white.svg';
import VerifiedNotificationPopup from '../../pages/verifiedNotificationPopup';
import womanPrivate from '../../assets/images/woman-blur-match-queue.webp';
import manPrivate from '../../assets/images/man-blur-match-queue.webp';
import AppConstants from '../../appConstants';
import webServices from '../../services/webServices';
import ConfirmationModal from '../modals/confirmationModal';

const convertHeightToFeetAndInches = (decimalHeight) => {
  if (!decimalHeight) return '';

  const feet = Math.floor(decimalHeight);
  const inches = Math.round((decimalHeight - feet) * 12);
  return `${feet}’ ${inches}”`;
};

const getImgBlurClass = (current, isProfilePrivate) => {
  if (isProfilePrivate === 'YES') return '';

  return current?.isPlanExpired === true || current?.status === 'PENDING' ? 'blur_img' : '';
};

// FREE MODE (sheet #19): only the hidden member badge used this.
// const BADGE_CLASS = 'img-fluid verifid_img cursor-pointer';

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

const GridViewComponent = (props) => {
  const {
    current,
    matchData,
    toggleFilterPopupVisibility,
    profileCardClickHandler,
    resetFilterHandler,
    checkIfFilterApplied,
    pageQueryParam
  } = props;

  // const getProfileImage = () => 'no_Image.svg';
  const getProfileImage = (userData) => {
    if (userData?.isProfilePrivate === 'YES') {
      return current.gender === 'MAN' ? womanPrivate : manPrivate;
    }
    return process.env.REACT_APP_PIC_BASE_URL + (userData?.images && userData?.images.length ? userData?.images[0] : 'no_Image.svg');
  };

  return (
    <>
      <div className='new_match_que my_matches_new'>
        <div className='inner-container'>
          {
            pageQueryParam === null && (
              <div className='topbar'>
                <h3>Discover</h3>
                <div className='rightbar'>
                  <button type='button' className='filter' onClick={() => toggleFilterPopupVisibility(true)}>
                    match preferences <img className='ml-2' src={filterIconwhite} alt="/" />
                  </button>
                  {checkIfFilterApplied(current) && (
                    <button type='button' className='btn reseFilter' onClick={resetFilterHandler}>
                      <span className='icons'><img className='' src={resetFilterIcons} alt="reset filter" /></span>
                      <span className='reset'>Reset Filter</span>
                    </button>
                  )}
                </div>
              </div>
            )
          }

          <div className='list_wrapper'>
            {
              // eslint-disable-next-line no-nested-ternary
              matchData.length > 0 ?
                matchData.map((userData, profileIdx) => (
                  <div key={`grid-view-${userData.userId}`} className={`card card-${userData.userId}`} onClick={() => profileCardClickHandler(profileIdx)} role='button' tabIndex={0} onKeyDown={() => { }}>
                    <figure>
                      <img src={getProfileImage(userData)} className={getImgBlurClass(current, userData?.isProfilePrivate)} alt="/" />
                    </figure>
                    <caption>
                      <div className='row align-center'>
                        <div className='col-6'>
                          <div className='row align-center'>
                            <div className='col-6'> <h3>{userData?.userName} <div className="start"> ***</div> </h3></div>
                            {/* FREE MODE (sheet #19): member badge hidden — <div className='col-6 p-0'><div className='vipDec'><PlanBadge user={userData} /></div></div> */}
                          </div>
                        </div>
                        <div className='col-6 pl-3'>
                          <div className='row align-center age_birth'>
                            <div className='col-6'> <img className='ageIcon mr-2' src={ageIconWhite} alt="" />{userData?.userAge}</div>
                            <div className='col-6  p-0'>{convertHeightToFeetAndInches(userData?.height)}</div>
                          </div>
                        </div>
                      </div>
                      <div className='row align-center'>
                        <div className='col-6 even_des mt-2'>{userData?.occupation}</div>
                        <div className='col-6 even_des mt-2'><ResidenceCity address={userData?.addressObj} isProfilePrivate={userData?.isProfilePrivate} /></div>
                      </div>
                      <div className='row align-center'>
                        <div className='col-6 even_des mt-2'>{userData?.uDetails?.educationLabel}</div>
                        <div className='col-6 even_des mt-2'><OriginState uDetails={userData?.uDetails} /></div>
                      </div>
                    </caption>
                    <div className='view_profile'>
                      {
                        // eslint-disable-next-line no-nested-ternary
                        userData?.isSecondAttempt === 1
                          ? (<button className='box second_chance_wrapper' type='button'>
                            <span className='icon'> <img src={heartwhite} alt="/" /></span>
                            <span className='second_change'><span className='top'>2nd chance because</span>
                              <span className='bottom'> {userData?.userName}** <span className='color'>LIKED</span> YOU</span></span>
                          </button>)
                          : (
                            // eslint-disable-next-line no-nested-ternary
                            userData?.rosesSentToMe > 0
                              ? (<button className='box send_rose' type='button'>
                                <span className='icon'> <img src={rose} alt="/" /></span>
                                <span className='label'>
                                  <span className='top'>{userData?.userName}** send you</span>
                                  <span className='bottom'><span className='color'>{userData?.rosesSentToMe} </span>roses</span>
                                </span>
                              </button>)
                              : (
                                userData?.isLikeMe
                                  ? (
                                    <button className='box like_you' type='button'>
                                      <span className='icon'> <img src={heartwhite} alt="/" /></span>
                                      <span className='like_name'> {userData?.userName}** <span className='color'>LIKED</span> YOU</span>
                                    </button>)
                                  : (<></>)
                              )
                          )
                      }
                      <button className='box ' type='button'>
                        <span className='view_profile_name'>View Profile</span>
                        <span className='icon'><i className='fa fa-angle-right' /></span>
                      </button>
                      {/* <button className='box second_chance_wrapper' type='button'>
                        <span className='view_profile_name'>View Profile</span>
                        <span className='icon'><i className='fa fa-angle-right' /></span>
                      </button> */}
                    </div>
                  </div>
                )) :
                (
                  pageQueryParam === null
                    ? (<div>No Matches Found.<br /><br /> Please reduce your match preference selection to increase available matches.</div>)
                    : (<div>No data Found.</div>)
                )
            }
          </div>
        </div>
      </div>
    </>
  );
};

const SingleProfileViewComponent = (props) => {
  const { current, planDetails, data, handleDislike, handleLike, handleSendRose, gridViewToggleHandler, pageQueryParam } = props;
  const {
    // userId,
    images,
    userName,
    userAge,
    // dob,
    about,
    hobbies,
    // qualities,
    occupation,
    address,
    isSentRose,
    isLikeMe,
    rosesSentToMe,
    isISentRose,
    isILike,
    uDetails,
    // status,
    // phone,
    isProfilePrivate,
    privateAddress,
    height
  } = data;

  const { origin1, origin2, origin3 } = uDetails;

  const getSliderImagesArr = () => images && images.length ? images : ['no_Image.svg'];

  const [verifyMsg, setVerifyMsg] = useState(false);
  const handleCloseVerifyMsg = () => setVerifyMsg(false);

  const [userBlockModalConfig, setUserBlockModalConfig] = useState({ message: '', isVisible: false });
  const handleCloseUserBlockModal = () => setUserBlockModalConfig({ message: '', isVisible: false });

  useEffect(() => {
    const logProfileVisit = async () => {
      if (data?.userId) {
        await webServices.logProfileVisit(data.userId);
      }
    };

    logProfileVisit();
  }, [data?.userId]);

  const skipUserProfile = () => handleDislike(true);

  const blockUserButtonHandler = () => {
    const message = `Blocking '${userName}' means that you and '${userName}' will no longer be able to view each other's profile or communication with each other. This change is permanent and cannot be undone.`;
    setUserBlockModalConfig({ message, isVisible: true });
  }

  const blockUserConfirmHandler = () => {
    handleDislike();
    handleCloseUserBlockModal();
  }

  return (
    <>
      <div className="justify-content-center new_matches_design">
        <div className="inerSection">
          <div className='go_back_wrapper'>
            <button type='button' onClick={() => gridViewToggleHandler(null, false)} className="go_to_back"><img className='' src={Back} alt="" /> go Back</button>
          </div>

          <div className="image-slider-box d-inline-block">
            {isLikeMe && (
              <div className="alredy-likeu">
                <img src={alreadylike} alt="/" />
                <div>{userName.charAt(0).toUpperCase()}. already likes you</div>
              </div>
            )}
            <ImageSlider2
              images={getSliderImagesArr()}
              isSentRose={isSentRose}
              rosesSentToMe={rosesSentToMe}
              isProfilePrivate={isProfilePrivate}
              privateImage={current.gender === 'MAN' ? womanPrivate : manPrivate}
              blurImgClass={getImgBlurClass(current, data?.isProfilePrivate)}
            />
            <div className={`match-action-btns ${data.isSecondAttempt === 1 ? 'match-action-btns-second-chance' : ''}`}>
              <div
                onClick={skipUserProfile}
                onKeyDown={(event) => event.key === 'Enter' && skipUserProfile}
                role="button"
                tabIndex="0"
                className="btn1 smallBtn"
              >
                {/* <img src={closeImg} alt="/" /> */}
                <img className='skip' src={skipImg} alt="/" />
              </div>
              <div
                className={`rose-box btn1 ${pageQueryParam === 'send-roses' || isISentRose === true ? 'disabled pointer-disabled' : ''}`}
                onClick={handleSendRose}
                onKeyDown={(event) => event.key === 'Enter' && handleSendRose}
                role="button"
                tabIndex="0"
              >
                <img
                  src={rose}
                  className="img-rose-fluid"
                  alt="Lovrican rose"
                />
              </div>
              <div
                className={`btn1 btn2 smallBtn position-relative ${pageQueryParam === 'send-roses' || isILike === true ? 'disabled pointer-disabled' : ''}`}
                onClick={handleLike}
                onKeyDown={(event) => event.key === 'Enter' && handleLike}
                role="button"
                tabIndex="0"
              >
                <img className='heartImg' src={heart} alt="/" />
                <img className='heartImg yellowImg' src={heart2} alt="/" />
                {data.isSecondAttempt === 1 && (
                  <div className='secondChance'>2nd chance</div>
                )}
              </div>

            </div>
            <div className='match-action-btns-lebael'>
              <p>Skip User</p>
              <p>Send Roses</p>
              <p className='position-relative'>
                Like User
                <span className="tooltip-text">{planDetails.dailyLikeLimit} {planDetails.dailyLikeLimit !== 1 ? 'LIKES' : 'LIKE'} LEFT</span>
              </p>
            </div>
          </div>
          <div className="user-detail-box d-inline-block v-top">
            <div className="usr-info-box">
              <h5>
                <span className="match_name" title={userName}>
                  {userName.charAt(0).toUpperCase()}
                </span>
                <span className="dotAge">&#8226;</span>
                {userAge}
                {/* FREE MODE (sheet #19): member badge hidden — &nbsp;<span><PlanBadge user={data} iconOnly className={BADGE_CLASS} /></span> */}
              </h5>
              {occupation ? (
                <p className="occupation">
                  {occupation}{' '}
                  {uDetails?.jobTitle ? `(${uDetails?.jobTitle})` : ''}
                  {uDetails?.companyName ? ' at ' : ''}
                  {uDetails?.companyName}
                </p>
              ) : (
                <p className="occupation missting_section_match">
                  Occupation to be added
                </p>
              )}
              {isProfilePrivate === 'NO'
                ? address && <p className="prfl_city">{address}</p>
                : privateAddress && (
                  <p className="prfl_city">{privateAddress}</p>
                )}

              <p className="prf_height age_icon">
                <img src={ageIcon} alt="/" /> {userAge}
              </p>

              {height && (
                <p className="prf_height">
                  {convertHeightToFeetAndInches(height)}
                </p>
              )}
            </div>

            {data?.uDetails?.educationLabel && (
              <div className="about-me-box">
                <p className="head">Education:</p>
                <p className="about-dec">
                  {data?.uDetails?.educationLabel}
                  {data?.uDetails?.whatStudy && ` (${data?.uDetails?.whatStudy})`}
                  {data?.uDetails?.schoolName && ` from ${data?.uDetails?.schoolName}`}
                </p>
              </div>
            )}

            <div className="about-me-box">
              <p className="head">About Me:</p>
              {about ? (
                <p className="about-dec">{about}</p>
              ) : (
                <p className="about-dec missting_section_match">
                  Intro summary to be added
                </p>
              )}
            </div>

            {origin1 && origin2 && origin3 && (
              <div className="about-me-box">
                <p className="head">My Roots:</p>
                <p className="about-dec">
                  {JSON.parse(origin3).label}, {JSON.parse(origin2).label},{' '}
                  {JSON.parse(origin1).label}
                </p>
              </div>
            )}

            {data?.uDetails?.lookingFor && (
              <div className="about-me-box">
                <p className="head">Looking for:</p>
                <p className="about-dec">{data?.uDetails?.lookingFor}</p>
              </div>
            )}

            <div className="ul-li-box hobbies-wrapper">
              <p className="head pb-2">Hobbies:</p>
              {hobbies ? (
                <ul className="color-list">
                  {hobbies.map((prop) => (
                    <li key={prop.label}>{prop.label}</li>
                  ))}
                </ul>
              ) : (
                <ul className="color-list missting_section_match">
                  <li>Hobbies to be added</li>
                </ul>
              )}
            </div>
            <div className='blockUserProfile'>
              <button type='button' className='btn btn-block' onClick={blockUserButtonHandler}>
                <span>Block this user</span>
                <img src={blockImg} alt="block user" />
              </button>
            </div>
          </div>
        </div >
      </div >

      <VerifiedNotificationPopup
        modalStatus={verifyMsg}
        handleClose={handleCloseVerifyMsg}
        userDetails={current}
      />

      <ConfirmationModal
        isVisible={userBlockModalConfig.isVisible}
        heading="Block User"
        message={userBlockModalConfig.message}
        confirmBtnHandler={blockUserConfirmHandler}
        confirmBtnText="Yes, Block"
        cancelBtnHandler={handleCloseUserBlockModal}
        cancelBtnText="Cancel"
      />
    </>
  );
};

const ProfileBox = (props) => {
  const history = useHistory();
  const { current, userListingView, setUserListingView, setMatchProfile, toggleFilterPopupVisibility, resetFilterHandler } = props;

  const gridViewToggleHandler = (profileIdx, switchToSingleView = true) => {
    if (current?.status === 'PENDING') {
      history.push(AppConstants.routes.congratulations);
      // } else if (current?.isPlanExpired === true) {
      //   handleOpenInactivePlanPopup(true);
    } else {
      setUserListingView(`${switchToSingleView ? 'single' : 'grid'}-view`);
      if (switchToSingleView) {
        setMatchProfile(profileIdx);
      }

      setTimeout(scrollToTop, 250);
    }
  };

  return (
    <>
      {/* <FloatingLeftNav /> */}

      {
        userListingView === 'grid-view' ?
          <GridViewComponent  {...props} toggleFilterPopupVisibility={toggleFilterPopupVisibility} profileCardClickHandler={gridViewToggleHandler} resetFilterHandler={resetFilterHandler} /> :
          <SingleProfileViewComponent {...props} gridViewToggleHandler={gridViewToggleHandler} />
      }
    </>
  );
};

export default ProfileBox;
